import {ref} from 'vue';

let cart = ref(null);


async function add(uid) {
    return $api.payment.addToCart(uid).then(resp => {
        cart.value = resp.data;
        // app.config.globalProperties.$user.cart = resp.data;
    })
}

async function removeItem(uid) {
    return $api.payment.removeCartItem(uid).then(resp => {
        cart.value = resp.data;
        // app.config.globalProperties.$user.cart = resp.data
    })
}


async function get() {
    return $api.payment.getCart().then(resp => {
        cart.value = resp.data;
        // app.config.globalProperties.$user.cart = resp.data;
    })
}


export default {
    add, removeItem, get, cart
}
